window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoSuperskokRepo = function () {

    var url = 'api/casinosuperskok';

    var rezultati = function (kampanja) {
        return fetch(url + casino.repos.base.serializeGetParams({
            kampanja: kampanja
        }), {
            credentials: repos.base.credentials
        })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    var rezultatiIgrac = function (playerId, kampanja) {
        return fetch(url + casino.repos.base.serializeGetParams({
            playerId: playerId,
            kampanja: kampanja
        }), {
            credentials: repos.base.credentials
        })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        rezultati: rezultati,
        rezultatiIgrac: rezultatiIgrac
    }
}();